export default function LoadConference() {
  return (
    <div className="bg-stone-900 flex justify-center items-center h-screen w-screen">
      <p className="text-white font-bold text-2xl">Connexion en cours...</p>
    </div>
  );
}
